/* global axios */
import ApiClient from './ApiClient';

class WhatsappImportAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  parse(conversationId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/conversations/${conversationId}/whatsapp_imports/parse`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  import(conversationId, file, senderMap) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sender_map', JSON.stringify(senderMap));
    return axios.post(
      `${this.apiVersion}/accounts/${this.accountIdFromRoute}/conversations/${conversationId}/whatsapp_imports`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
  }

  // eslint-disable-next-line class-methods-use-this
  get accountIdFromRoute() {
    const match = window.location.pathname.match(/accounts\/(\d+)/);
    return match ? match[1] : '';
  }
}

export default new WhatsappImportAPI();
